import { useMediaQuery } from '@hub/hooks/useMediaQuery';
import { useEffect, useState } from 'react';
import tailwindConfig from '../../tailwind.config';

export interface ActiveBreakpoints {
  sm: boolean;
  md: boolean;
  lg: boolean;
  xl: boolean;
  available: boolean; // weather the first render has been done and the breakpoint values are correct
}

/**
 * custom hook to make use of the tailwind breakpoints, see also
 * https://dev.to/justincy/4-patterns-for-responsive-props-in-react-39ak
 */
/**
 * @deprecated Use 'react-device-detect' instead.
 */
export function useBreakpoints(): ActiveBreakpoints {
  const { screens } = tailwindConfig.theme;
  const [available, setAvailable] = useState(false);
  useEffect(() => {
    setAvailable(true);
  }, []);
  return {
    sm: useMediaQuery(`(min-width: ${screens.sm})`),
    md: useMediaQuery(`(min-width: ${screens.md})`),
    lg: useMediaQuery(`(min-width: ${screens.lg})`),
    xl: useMediaQuery(`(min-width: ${screens.xl})`),
    available,
  };
}
